import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CmsConfig, ConfigModule, OccConfig } from '@spartacus/core';
import { UigPipesModule } from 'src/app/pipes/uig-pipes.module';
import { UigQuestionnaireFormComponent } from './uig-questionnaire-form.component';



@NgModule({
  declarations: [UigQuestionnaireFormComponent],
  imports: [
    CommonModule,
    UigPipesModule,
    ReactiveFormsModule,
    FormsModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        QuestionnaireFormComponent: {
          component: UigQuestionnaireFormComponent
        }
      },
    }),
    ConfigModule.withConfig({
      backend: {
         occ: {
           endpoints: {
             questionnaireSubmit: '/questionnaire/submit/${formName}'
           },
         },
       },
     } as OccConfig)
  ]
})
export class UigQuestionnaireFormModule { }
